export { default } from './Transition';



// WEBPACK FOOTER //
// ./src/universal/components/Transition/index.js